import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-descend",
  "use": "icon-descend-usage",
  "viewBox": "0 0 8 9",
  "content": "<symbol viewBox=\"0 0 8 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-descend\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 9L0 4.5H2.5V0H5.5V4.5H8L4 9Z\" fill=\"#EB3131\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol